import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControlKeyLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"control-key-left"} maskId="square-filled-radius-0-stroke-1-IconControlKeyLeft"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM9 6.79289L5.79289 10L6.5 10.7071L9 8.20711L11.5 10.7071L12.2071 10L9 6.79289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconControlKeyLeft;
